export default __webpack_public_path__ + "static/media/linkedin.35f0e728.svg";